<script>
	export let blok;
</script>

{#if blok?.headline}
	<div class="box-x-wrapper">
		<h1 class="text-black text-h-32 lg:text-h-72 lg:my-10">{blok.headline}</h1>
	</div>
{/if}
